import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GgwProfile} from "@catmodels/ggw-profiles/types";
import {isNullOrUndefined} from "util";
import {FormBuilder, FormGroup} from "@angular/forms";
import {StyleType} from "@catui/types";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {NotificationsService} from "@catcore/services";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {EntitySchemaType} from "@catcore/utils/json-schema/entity-schema-to-json-schema";
import {buildFormControlsFromSchema} from "@catuiform/shared/form-builder";

@Component({
  selector: 'catapp-modify-ggw-device',
  templateUrl: './modify-ggw-device.component.html',
  styleUrls: ['./modify-ggw-device.component.scss']
})
export class ModifyGgwDeviceComponent implements OnInit {

  private _ggwDevice;

  @Input() project = null;

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<any>();
  @Output() afterCreate = new EventEmitter<any>();

  @Input()
  get ggwDevice() {
    return this._ggwDevice;
  }

  set ggwDevice(value) {
    this._ggwDevice = value;
    if (!isNullOrUndefined(this._ggwDevice)) {
      this.form.patchValue(this._ggwDevice);
    }
  }

  labels = {
    name: 'Name',
    description: 'Description',
  };

  form: FormGroup;
  styleType = StyleType;

  private readonly modelSchema;

  constructor(private formBuilder: FormBuilder,
              private resourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private notification: NotificationsService,
              schemaService: EntitySchemaService) {
    this.modelSchema = schemaService.getForEntityName(EntitySchemaType['ProjectGgwDevices']);
    const formControls = buildFormControlsFromSchema(this.formBuilder, this.modelSchema);
    this.form = this.formBuilder.group(formControls);
  }

  ngOnInit() {
  }

  get dataIsReady() {
    return !isNullOrUndefined(this._ggwDevice);
  }

  saveGgwDevice() {
    const service = this.resourceService.findServiceForResource(this._ggwDevice._links.self.href);

    const formValue = this.form.value;
    const data = {
      name: formValue.name,
      config_name: formValue.config_name,
      description: formValue.description,
      gui_group_desc: formValue.gui_group_desc
    };

    const subscr = service
      .save(data)
      .finally(() => subscr.unsubscribe())
      .subscribe((res) => {
        this.notification.success('Update successful', 'GGW Device has been saved.');
        this.activeModal.close();
        this.afterUpdate.emit(res);
      });
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-device/components/modify-ggw-device/modify-ggw-device.component.ts